export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            routes: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        routes(state) {
            return state.routes.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setRoute(state, routes) {
            state.routes = routes
        },
    },

    actions: {
        async getRoutes(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-routes`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setRoute', res.data.routes);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveRoute(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-route';
            } else {
                url = 'add-route';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getRoutes');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteRoute(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-route/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getRoutes');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },
    }
}
